import PropTypes from 'prop-types';
import { PLAN_ROW_ITEM_PROP_TYPES } from '../plan-row-item/constants';

export const PAYWALL_ROW_ITEM_PROP_TYPES = {
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  highlight: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onTooltipHover: PropTypes.func,
  availabilities: PropTypes.arrayOf(
    PropTypes.shape({
      ...PLAN_ROW_ITEM_PROP_TYPES,
      id: PropTypes.string.isRequired,
    })
  ).isRequired,
};
